export default {
  signIn: 'Se connecter',
  signUp: "S'inscrire",
  email: 'Courriel',
  emailPlaceholder: 'Entrez votre courriel',
  password: 'Mot de passe',
  passwordPlaceholder: 'Entrez votre mot de passe',
  forgotPassword: 'Mot de passe oublié ?',
  confirmPassword: 'Confirmer le mot de passe',
  confirmPasswordPlaceholder: 'Confirmez votre mot de passe',
  noAccount: "Vous n'avez pas de compte ?",
  hasAccount: 'Vous avez déjà un compte ?',
  signInWithGoogle: 'Se connecter avec Google',
  signUpWithGoogle: "S'inscrire avec Google",
  signInCta: 'Se connecter',
  signUpCta: "S'inscrire",
  signUpCtaSubmitting: 'Inscription en cours...',
  changeEmail: 'Modifier mon courriel',
  updateEmailFailed: 'Échec de la mise à jour du courriel. Veuillez réessayer.',
  currentEmailDoesNotMatch:
    'Ce courriel ne correspond pas à votre courriel actuel. Entez votre courriel actuel',
  passwordUpdated: 'Votre mot de passe a été mis à jour avec succès.',
  currentPasswordDoesNotMatch: 'Le mot de passe actuel est invalide, veuillez réessayer.',
  emailTakenException: 'Ce courriel est déjà pris.',
  enableAuthCTA: 'Continuer avec Google Authenticator',
  disableAuthCTA: "Desactiver l'authentification à deux facteurs",
  confirmDisable: 'Confirmer la desactivation',
  authCTADesableHint: 'Entrer votre code à 6 chiffres pour desactiver le 2FA',
  authCTAScan: "Scanner ce QR code avec votre application d'authentication",
  authCTAVerify: 'Entrer le code de vérification',
  codePlaceholder: 'Code de vérification ...',
  authCTAGenericError: "Une erreur s'est produit",
  downloadGoogleAuth:
    'L’authentification à deux facteurs requiert le téléchargement de l’application Google Authentificator',
  register: {
    title: 'Inscription',
    userType: 'Je suis un...',
    client: 'Client',
    freelancer: 'Freelance',
    submit: 'Créer un compte',
    signInCta: 'Connectez-vous',
    dataProtection: {
      title: 'Protection de vos données (Loi 25) :',
      paragraph1:
        "Chez Pigeons, nous utilisons vos données uniquement pour vous offrir notre service : créer votre profil, gérer vos projets et vous mettre en relation avec vos prospects potentiels. Vos informations peuvent être partagées avec les utilisateurs concernés lorsque c'est nécessaire pour une mise en contact ou une collaboration.",
      paragraph2:
        'Nous utilisons aussi certaines données de manière agrégée pour améliorer la plateforme et nos fonctionnalités. Nous ne vendons jamais vos données.',
      paragraph3:
        "En tout temps, vous pouvez demander l'accès, la correction ou la suppression de vos renseignements personnels.",
    },
    acceptTerms: {
      prefix: "J'accepte les",
      termsOfUse: "Conditions d'utilisation",
      and: 'et la',
      privacyPolicy: 'Politique de confidentialité',
      suffix:
        ", et je comprends l'utilisation de mes données personnelles telle que décrite ci-dessus.",
    },
    acceptNotifications:
      "J'accepte de recevoir des notifications liées à mes activités sur Pigeons (soumissions, messages, projets, etc.).",
    acceptNewsletter:
      'Je veux rester connecté·e à la communauté Pigeons — infolettres, nouveautés et contenus utiles.',
  },
  errors: {
    createAccount: 'Veuillez compléter les informations du compte avant de continuer.',
    emailInvalid: 'Veuillez entrer une adresse courriel valide.',
    emailRequired: 'Veuillez entrer votre adresse courriel.',
    emailRateLimited: 'Trop de tentatives de courriel. Veuillez patienter un moment.',
    resetPassword:
      "Nous n'avons pas pu envoyer le courriel de réinitialisation. Veuillez réessayer.",
    invalidCredentials: 'Courriel ou mot de passe invalide',
    accountCreation: 'Erreur lors de la création du compte',
    generic: 'Une erreur inconnue est survenue. Veuillez contacter le support.',
    passwordTooShort: 'Le mot de passe doit comporter au moins 8 caractères.',
    passwordUpperLower: 'Le mot de passe doit contenir une majuscule et une minuscule.',
    passwordNumberOrSpecial: 'Le mot de passe doit contenir un chiffre ou un caractère spécial.',
    passwordInvalid: 'Mot de passe incorrect',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
  },
  firstName: 'Prénom',
  firstNamePlaceholder: 'Entrez votre prénom',
  acceptTerms: "J'accepte les",
  termsOfUse: "Conditions d'utilisation",
  and: 'et',
  privacyPolicy: 'Politique de confidentialité',
  completeSignup: 'COMPLÉTER SON INSCRIPTION',
  confirmEmail: {
    title: 'Vérifiez vos courriels',
    description:
      "Nous venons d'envoyer un lien de confirmation à <bold>{{email}}</bold>. Cliquez sur le lien pour poursuivre votre inscription.",
    resend: 'Renvoyer le courriel',
    resendIn: 'Renvoi possible dans {{minutes}} min...',
    back: "Retour à l'accueil",
    newEmail: 'Votre nouveau courriel',
    confirmNewEmail: 'Confirmer nouveau courriel',
    oldEmail: 'Votre actuel courriel',
    confirmReceived: 'J’ai reçu le courriel',
    emailInstruction: 'Veuillez vérifier votre boîte de réception à l’adresse',
    close: 'Fermer',
    confirmationNotice: 'Vous recevrez un courriel avec un lien de confirmation.',
    sendLinkCurrentEmail: 'Nous venons d’envoyer un courriel à votre ',
    sendLinkNewEmail: 'Nous venons d’envoyer un courriel à votre ',
    newEmailIsNowEffective: 'Votre nouveau courriel est maintenant effectif.',
    securityNoticeCanContinue:
      'Vous avez confirmé votre nouveau courriel Vous pouvez maintenant l’utiliser pour vous connecter',
    securityNotice:
      'Pour des raisons de sécurité, vous devez d’abord confirmer votre demande de modification de courriel.',
    securityNoticeHaveConfirmed:
      'Vous avez confirmé la demande de modification de courriel.Vous recevrez maintenant un courriel avec un lien de confirmation à votre nouvelle adresse',
    newAddress: 'nouvelle adresse',
    currentAddress: 'adresse actuelle',
  },
  profileTypeStep: {
    welcome: 'Bienvenue sur Pigeons',
    step: 'Étape 1 de 3',
    completeInfo: 'Choisir votre type de profil',
    stepDesc: 'Première étape sur trois pour finaliser votre abonnement.',
    freelancerDescription:
      'En tant que pigiste, vous pouvez mettre en avant vos compétences, postuler à des projets et entrer en contact avec des clients à la recherche de votre expertise. Créez un profil attractif pour développer votre carrière indépendante sur Pigeons.',
    recruiterDescription:
      'En tant que recruteur, vous pouvez publier des projets, consulter les profils de pigistes et trouver les talents idéaux pour vos besoins. Gérez vos équipes et vos projets efficacement grâce à nos outils dédiés aux entreprises et organisations.',
    inscription: 'Inscription',
    as: 'Vous vous inscrivez en tant que :',
    freelancer: 'Pigiste',
    recruiter: 'Recruteur',
    professional: 'Personnel',
    company: 'Corporatif',
    organization: 'Organisation',
  },
  completeProfileStep: {
    welcome: 'Bienvenue sur Pigeons',
    step: 'Étape 2 de 3',
    completeInfo: 'Compléter les informations essentielles',
    stepDesc: 'Deuxième étape sur trois pour finaliser votre abonnement.',
    info1:
      "Pour nous aider à personnaliser votre expérience et à vous mettre en relation avec les bonnes opportunités, veuillez compléter les informations essentielles ci-dessous. Cela nous permettra d'associer plus facilement votre profil à des projets et clients correspondant à vos compétences et préférences.",
    info2:
      'Vos informations resteront confidentielles et ne seront utilisées que pour améliorer votre expérience sur Pigeons. Plus votre profil est complet, plus il sera facile pour les clients de vous trouver et de vous faire confiance.',
    inscription: 'Inscription',
    professionalInfo: 'Quelles sont vos informations professionnelles?',
    chooseImage: 'Photo de profil*',
    imageHint: "Optimal: format carré d'au moins 675px par 675px. Taille maximale: 5MB",
    uploading: 'Téléchargement...',
    profilePreviewAlt: 'Aperçu du profil',
    personalInfoDescriptionTitle: 'Vous recrutez des talents locaux pour vos besoins personnels.',
    personalInfoDescriptionSubtitle:
      'Ex : photographie familiale ou événementielle,impôts personnels, services notariaux, projets créatifs ou à domicile, etc.',
    corporateInfoDescriptionTitle: 'Vous recrutez au nom d’une entreprise ou d’une organisation.',
    corporateInfoDescriptionSubtitle:
      'Cela inclut:  propriétaires d’entreprise, les spécialistes en marketing, les professionnels en RH, etc.',
    organizationInfoDescriptionTitle: 'Vous recrutez au nom d’une organisation.',
    organizationInfoDescriptionSubtitle:
      'Ajoutez vos informations organisationnelles pour que notre équipe puisse valider votre statut OBNL.',
  },
  lastName: 'Nom',
  lastNamePlaceholder: 'Entrez votre nom',
  city: 'Ville',
  cityPlaceholder: 'Entrez votre ville',
  servicesOffered: 'Services offerts',
  servicesHint: 'Ajouter un autre service',
  languagesSpoken: 'Langue(s) parlée(s)',
  remoteWork: 'Travaillez-vous à distance',
  yes: 'Oui',
  professionalDescription: 'Décrivez votre pratique professionnelle',
  professionalDescriptionPlaceholder:
    'Décrivez votre expérience professionnelle, vos compétences et ce qui vous rend unique',
  professionalDescriptionNotice:
    'Les coordonnées personnelles ne sont pas permises dans les profils, mais pas de stress, elles sont partagées automatiquement une fois le contact établi sur Pigeons!',
  charactersRemaining: 'caractères restants',
  businessIndustries: "Secteurs d'activité",
  companyIndustries: 'Votre entreprise en quelques mots',
  businessIndustriesHint: 'Ajouter minimum 1 secteur',
  companyName: 'Nom de la société',
  companyNamePlaceholder: 'Entrez le nom de votre société',
  organizationWebsite: "Site web de l'organisation",
  organizationWebsitePlaceholder: "Entrez le site web de l'organisation",
  organizationNumber: "Numéro de l'organisation",
  organizationNumberPlaceholder: "Entrez le numéro de l'organisation",
  organizationIdentityHint:
    "Ajoutez au moins un identifiant d'organisation : site web ou numéro d'organisation.",
  organizationIdentityRequired:
    "Ajoutez au moins un identifiant d'organisation : site web ou numéro d'organisation.",
  contactFirstName: 'Prénom du contact',
  contactLastName: 'Nom du contact',
  contactRoleInCompany: "Rôle du contact au sein de l'entreprise",
  jobTitle: "Votre rôle au sein de l'entreprise",
  jobTitlePlaceholder: "Entrez votre rôle au sein de l'entreprise",
  back: 'Retour',
  completeProfileCta: 'Compléter',
  completeProfileCtaSubmitting: 'Complétion du profil...',
  fieldRequired: 'Ce champ est requis.',
  profileUpdateError: 'Erreur lors de la mise à jour du profil. Veuillez réessayer.',
  profileUpdateSuccess: 'Profil mis à jour avec succès !',
  improveProfileStep: {
    welcome: 'Bienvenue sur Pigeons',
    tabs: {
      settings: 'Mes paramètres',
      edit: 'Modifier mon profil',
      services: 'Mes services',
      achievements: 'Mes réalisations',
      security: 'Authentification et sécurité',
      publicProfile: 'Mon profil public',
    },
    step: 'Étape 3 de 3',
    completeInfo: 'Bonifier votre profil et maximiser vos chances!',
    stepDesc:
      "Un profil complet attire davantage l'attention des recruteurs, des partenaires potentiels et des collègues. Cela augmente vos chances d'être remarqué et contacté pour des opportunités intéressantes.",
    save: 'Enregistrer',
    services: {
      title: 'Mes services',
      toImplement: 'Mes services - à implémenter',
      label: 'Services offerts',
      placeholder: 'Choix',
      hourlyRate: 'Taux horaire',
      add: 'Ajouter un service',
      remove: 'Retirer',
    },
    achievements: {
      title: 'Mes réalisations',
      toImplement: 'Mes réalisations - à implémenter',
      projectName: 'Nom du projet',
      client: 'Client',
      description: 'Description',
      projectDetailsLabel: 'Détails sur le projet',
      projectDetailsPlaceholder:
        'Décris le projet réalisé? Mentionne le contexte, ton rôle et le résultat obtenu.',
      serviceOffered: 'Service offert',
      uploadImage: 'Téléverser une photo de profil',
      add: 'Ajouter une réalisation',
      close: 'Abandonner et fermer',
      saving: 'Enregistrement...',
      imageUploadHint: 'Ajouter une photo de profil',
      modify: 'Modifier une réalisation',
      save: 'Enregistrer',
      delete: 'Supprimer la réalisation',
      imageSize: "La taille maximale d'une image est de 5 MB",
      deleteSuccess: 'Réalisation supprimée avec succès.',
      deleteError: 'Échec de la suppression de la réalisation.',
    },
    security: {
      title: 'Sécurité et mot de passe',
      toImplement: 'Sécurité et mot de passe - à implémenter',
      changePassword: 'Modifier mon mot de passe',
      currentPassword: 'Votre mot de passe actuel',
      newPassword: 'Votre nouveau mot de passe',
      twoFA: 'Authentification à deux facteurs',
      activated: 'Activée',
      deactivated: 'Désactivée',
      phone: 'Votre numéro de téléphone',
      confirmPhone: 'Confirmer votre numéro de téléphone',
      passwordResetLinkSent: 'Nous venons d’envoyer un courriel de confirmation.',
      passwordResetHint:
        'Vous recevrez un courriel avec un lien de confirmation de modification de votre mot de passe',
      passwordResetEffective: 'Votre nouveau mot de passe est maintenant effectif.',
      passwordResetConfirmed:
        'Vous avez confirmé votre nouveau mot de passe.Vous pouvez maintenant l’utiliser pour vous connecter.',
    },
  },
  postalCodePlaceholder: 'Entrez votre code postal',
  phonePlaceholder: 'Entrez votre numéro de téléphone',
  postalCode: 'Code postal',
  phone: 'Téléphone',
  saving: 'Enregistrement...',
  submitting: 'Envoi en cours...',
  backToHome: "Retour à l'accueil",
  resetPasswordCta: 'Réinitialiser le mot de passe',
  resetPassword: {
    title: 'Réinitialiser le mot de passe',
    description: 'Veuillez entrer votre nouveau mot de passe ci-dessous.',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le nouveau mot de passe',
    save: 'Enregistrer',
    resetLinkSent:
      "Nous venons d'envoyer un lien de réinitialisation à <bold>{{email}}</bold. Cliquez sur le lien pour poursuivre la récupération de votre mot de passe.",
    resend: 'Renvoyer le courriel de réinitialisation',
    resetPasswordCta: 'Réinitialiser',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    updateError: 'Échec de la mise à jour du mot de passe. Veuillez réessayer.',
    expiredTitle: 'Ce lien de réinitialisation a expiré',
    invalidLink:
      'Ce lien de réinitialisation est invalide ou expiré. Veuillez demander un nouveau courriel de réinitialisation.',
    sessionError:
      'Nous n’avons pas pu vérifier votre lien de réinitialisation. Veuillez demander un nouveau courriel et réessayer.',
    requestNewLink: 'Demander un nouveau lien',
  },
  common: {
    save: 'Enregistrer',
  },
  login: {
    error: 'Nous ne pouvons pas vous connecter. Vérifiez votre courriel et votre mot de passe.',
    invalid_credentials: 'Courriel ou mot de passe invalide.',
    email_not_confirmed: 'Veuillez confirmer votre adresse courriel avant de vous connecter.',
  },
  accountCard: {
    title: 'Mon compte',
    settings: 'Mes paramètres',
    wallet: 'Mon Porte-monnaie',
    payment: 'Paiement',
    signOut: 'Déconnexion',
  },
  demoWalkthroughStep: {
    welcome: 'Vous êtes prêt !',
    step: 'Une dernière chose...',
    completeInfo: 'Découvrez votre tableau de bord',
    stepDesc:
      "Avant de commencer, faites une visite guidée rapide pour découvrir comment fonctionne Pigeons. Cela ne prend qu'une minute et vous aidera à tirer le meilleur parti de la plateforme.",
    tryCta: 'Faire la visite guidée',
    skipCta: 'Passer au tableau de bord',
  },
  navBar: {
    prospects: 'Contacts',
    alliances: 'Alliances',
    jobs: 'Projets',
    bids: 'Soumissions',
    projects: 'Gestionnaire de projets',
    credits: 'Mes jetons',
    contacts: 'Contacts',
  },
} as const;
